import { icons } from 'common'
import { useYoloModal } from 'lib/yoloModals/useYoloModal'
import styled, { css } from 'styled-components'
import { CashOutAll } from './CashOutAll'
import { useMediaQuery } from 'utils/hooks/useMediaQuery'
import React, { useEffect } from 'react'
import { SingleContentToggle } from 'components/Atoms/SingleContentToggle'
import { Dropdown } from 'components/Atoms/Dropdown'
import { DropDownTabs } from './DropDownTabs'

const Tabs = ({ tabs = [], currentTab, onTabSelected }) => {
  const { updateModal } = useYoloModal()
  const isUnder1600 = useMediaQuery('(max-width: 1600px)')

  const RoiCalculatorModalObj = {
    show: true,
    id: 'roiCalculator',
    backdropBlurred: false,
  }
  const openRoiCalculatorModal = () => {
    updateModal(RoiCalculatorModalObj)
  }
  const FeeStructureModalObj = {
    show: true,
    id: 'feesStructure',
    backdropBlurred: false,
  }
  const openFeesStructureModal = () => {
    updateModal(FeeStructureModalObj)
  }

  const BidRulesModalObj = {
    show: true,
    id: 'bidRules',
    backdropBlurred: false,
  }
  const openBidRulesModal = () => {
    updateModal(BidRulesModalObj)
  }

  const isReactComponent = (content) => {
    return React.isValidElement(content)
  }

  return (
    <TabsContainer>
      <SingleContentToggle
        noWrapper
        toggle={isUnder1600}
        trueContent={<DropDownTabs tabs={tabs} onSelect={onTabSelected} activeTabId={currentTab} />}
        falseContent={tabs.map((tab) => (
          <div onClick={() => onTabSelected(tab.id)}>
            <SingleContentToggle
              noWrapper
              toggle={isReactComponent(tab.content)}
              trueContent={tab.content}
              falseContent={
                <Tab className={`${currentTab === tab.id ? 'activeTab' : ''}`} key={`tab-${tab.id}`}>
                  <>
                    {tab.content}
                    {tab.infoTooltip && (
                      <div
                        className='info_asset_icon hint--rounded hint--medium hint--top'
                        data-hint={tab.infoTooltip}
                      ></div>
                    )}
                  </>
                </Tab>
              }
            />
          </div>
        ))}
      />

      <TableHeadRightLinks>
        <Tab className='feesStructure' onClick={() => openBidRulesModal()}>
          RULES
        </Tab>
        <Tab className='feesStructure' onClick={() => openFeesStructureModal()}>
          FEES
        </Tab>
        <Tab className='roiCalculator' onClick={() => openRoiCalculatorModal()}>
          ROI CALC
        </Tab>
        <CashOutAll />
      </TableHeadRightLinks>
    </TabsContainer>
  )
}

export default Tabs

const activeTab = css`
  .activeTab {
    background: var(--bidding-table-tab-selected-background);
    font-weight: 600;
    margin-left: -1px;
    color: var(--bidding-table-tab-selected-text-color);
    text-shadow: var(--bidding-table-tab-selected-text-shadow);
  }
`
const TabsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 0 15px;
  height: 36px;
  white-space: nowrap;

  .feesStructure {
    position: relative;
    padding: 7px 10px 6px 10px;
    white-space: nowrap;
    position: relative;
    color: #fff;
  }
  .roiCalculator {
    position: relative;
    margin-left: auto;
    padding: 7px 34px 6px 10px;
    white-space: nowrap;
    position: relative;
    color: #fff;
  }
  .roiCalculator:before {
    position: absolute;
    content: '';
    width: 20px;
    height: 20px;
    right: 10px;
    background: url(${icons.calculator_icon}) center center / 20px auto no-repeat;
    z-index: 1;
    opacity: 0.8;
  }

  label.roiCalculator:hover {
    background: var(--tab-hover-background);
    font-weight: 600;
    color: var(--tab-hover-text-color);
    text-shadow: 0 0 10px var(--tab-hover-text-shadow);
  }

  ${activeTab}
`

const TableHeadRightLinks = styled.div`
  margin-left: auto;
  position: relative;
  display: flex;
  flex-direction: row;
`

const Tab = styled.label`
  cursor: pointer;
  padding: 12px 12px 10px 12px;
  margin: 0 2px;
  background: transparent;
  border-bottom: 0;
  display: flex;
  width: fit-content;
  border-radius: 10px;
  color: var(--tab-text-color);
  font-size: 0.75rem;
  align-items: center;

  &:hover {
    background: var(--tab-hover-background);
    font-weight: 600;
    color: var(--tab-hover-text-color);
    text-shadow: 0 0 10px var(--tab-hover-text-shadow);
  }
`
